import { useState, useRef, useCallback } from 'react';

interface HoneypotResult {
  honeypotProps: {
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    tabIndex: number;
    autoComplete: string;
    style: React.CSSProperties;
    'aria-hidden': boolean;
  };
  validateHoneypot: () => boolean;
}

const MIN_SUBMIT_MS = 2000;

export function useHoneypot(): HoneypotResult {
  const [honeypotValue, setHoneypotValue] = useState('');
  const mountedAt = useRef(Date.now());

  const validateHoneypot = useCallback((): boolean => {
    if (honeypotValue.length > 0) {
      console.warn('[honeypot] hidden field was filled — likely bot');
      return false;
    }
    const elapsed = Date.now() - mountedAt.current;
    if (elapsed < MIN_SUBMIT_MS) {
      console.warn(`[honeypot] submitted in ${elapsed}ms — likely bot`);
      return false;
    }
    return true;
  }, [honeypotValue]);

  const honeypotProps = {
    name: 'website_url',
    value: honeypotValue,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => setHoneypotValue(e.target.value),
    tabIndex: -1,
    autoComplete: 'off',
    style: {
      position: 'absolute' as const,
      left: '-9999px',
      top: '-9999px',
      opacity: 0,
      height: 0,
      width: 0,
      overflow: 'hidden' as const,
    },
    'aria-hidden': true as const,
  };

  return { honeypotProps, validateHoneypot };
}

export default useHoneypot;
